module.exports = __webpack_public_path__ + "img/hotel-8b.8e0bd294.jpeg";